export default "__VITE_PUBLIC_ASSET__e8695240__"